import { render, staticRenderFns } from "./ListCollectionCreator.vue?vue&type=template&id=26e89438&scoped=true"
import script from "./ListCollectionCreator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListCollectionCreator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListCollectionCreator.vue?vue&type=style&index=0&id=26e89438&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e89438",
  null
  
)

export default component.exports